import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import EnergySaleBlockData from '../../../Models/Content/EnergySaleBlockData';
import SaleHeader from './Partials/SaleHeader/SaleHeader';
import EnergySale from './energySale';

export default class EnergySaleBlock extends EpiComponent<EnergySaleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['energy-sale-jet-block'];
    if (this.props.data.padding?.value) cssClasses.push(this.props.data.padding?.value);
    if (this.props.data.margin?.value) cssClasses.push(this.props.data.margin?.value);

    return (
      <div className={cssClasses.join(" ")}>
        <div className="energy-sale-page-wrapper">
            <SaleHeader/>
            <EnergySale iContent={this.props.data} context={this.getContext()} />
        </div>
      </div>
    )
  }
}
